import { useCartMutationVariables } from "@/core/api/graphql/cart/composables";
import { useMutation } from "@/core/api/graphql/composables";
import { UpdateAccessoryDocument } from "@/core/api/graphql/types";
import type { CartIdFragment, CartExtension, InputUpdateAccessoryType } from "@/core/api/graphql/types";
import type { MaybeRef } from "vue";

export function useUpdateAccessoryMutation(cart?: MaybeRef<CartIdFragment | undefined>) {
  return useMutation(UpdateAccessoryDocument, useCartMutationVariables(cart));
}

/** @deprecated Use {@link useSetIntendsToExportMutation} instead. */
export async function updateAccessory(input: InputUpdateAccessoryType): Promise<CartExtension> {
  const { mutate } = useUpdateAccessoryMutation();
  const result = await mutate({ command: input });
  return result!.data! as CartExtension;
}
